import Entradas from "./Entradas";
export default Entradas;